import { useAppSelector } from 'app/hooks';
import { ConfigurationType } from 'data/types';
import useHybridLeftoverSpaceIds from 'hooks/use-hybrid-leftover-space-ids';
import { shallowEqual } from 'react-redux';
import { selectFetchedConfigurations } from 'utils/pathway-configurations';

export default function useFetchedConfigurations(): ConfigurationType[] {
  const leftoverSpaceIds = useHybridLeftoverSpaceIds();
  return useAppSelector(
    (state) => selectFetchedConfigurations(state, leftoverSpaceIds),
    shallowEqual
  );
}
